import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';

const baseUrl = environment.hostService + '/ResultPayroll' ;

@Injectable({
  providedIn: 'root'
})
export class ResuLiquidacionService {
   
  constructor(private _http: HttpClientService,
    private http: HttpClient,) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getDetail(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/Index?id=' + code })
  }

  Imprimir(id): Observable<any>
  {
    return this.http.get(baseUrl + '/Imprimir?resultPayrollId=' + id,{ responseType: 'blob' })
  }

  BuscarLiquidaciones(desde, hasta, periodo, grupo, legajoDesde, legajoHasta, sociedad, controlAsiento): Observable<any>
  {
    return this.http.get(baseUrl + '/BuscarLiquidaciones?fechaDesde=' + desde + '&fechaHasta=' + hasta + 
                                   '&periodo=' + periodo + '&grupo=' + grupo + '&legajoDesde=' + legajoDesde + 
                                   '&legajoHasta=' + legajoHasta + '&sociedad=' + sociedad + 
                                   '&controlAsiento=' + controlAsiento)
  }

  UltimasLiquidacionesByEsquema(esquema): Observable<any>
  {
    return this.http.get(baseUrl + '/UltimasLiquidacionesByEsquema?esquema=' + esquema)
  }

  GetTodasByLegajo(legajo): Observable<any>
  {
    return this.http.get(baseUrl + '/GetTodasByLegajo?legajo=' + legajo)
  }

  GetLiquidacionesBorrado(legajo, periodo): Observable<any>
  {
    return this.http.get(baseUrl + '/GetLiquidacionesBorrado?legajo=' + legajo + '&periodo=' + periodo)
  }

  BorrarLiquidacion(id): Observable<any>
  {
    return this.http.get(baseUrl + '/Delete?id=' + id)
  }

  TransferirLiquidacion(id): Observable<any>
  {
    return this.http.get(baseUrl + '/Transferir?id=' + id)
  }

  ReporteIPS(periodo, grupo): Observable<any>
  {
    return this.http.get(baseUrl + '/BuscarReporteIPS?periodo=' + periodo + '&grupo=' + grupo)
  }

  ReporteIRP(anio, grupo, legajo, sociedad, sede, grupoPer): Observable<any>
  {
    return this.http.get(baseUrl + '/BuscarReporteIRP?anio=' + anio + '&grupo=' + grupo + '&legajo=' + legajo +
                                   '&sociedad=' + sociedad + '&sede=' + sede + '&grupoPer=' + grupoPer)
  }

  ReporteMTESS(anio, grupo, legajo, sociedad): Observable<any>
  {
    return this.http.get(baseUrl + '/BuscarReporteMTESS?anio=' + anio + '&grupo=' + grupo + '&legajo=' + legajo +
                                   '&sociedad=' + sociedad )
  }

  ReporteTransferencia(periodo, grupo, banco): Observable<any>
  {
    return this.http.get(baseUrl + '/BuscarReporteTransferencia?periodo=' + periodo + '&grupo=' + grupo + '&banco=' + banco)
  }

  GetUltimoPeriodo(soloUltimo, fecha): Observable<any>
  {
    return this.http.get(baseUrl + '/GetUltimoPeriodo?soloUltimo=' + soloUltimo + '&fecha=' + fecha)
  }

  saveHistorial(registros): Observable<any> 
  {
    return this._http.post({ url: baseUrl + '/ImportarHistorial', body: registros });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        fecha: '00/00/0000',
        tipo: '', 
        codigoNomina: '',
        importeUnitario: '',
        cantidad: '',
        importe: '',
        errores: ['No Completar']}
    ];

    //personal, codigosNomina se deben validar que existan

    return formato;
  }

}
